module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ty_fail.83048749.png";